import { Box, Text, HStack, Flex, AspectRatio } from '@chakra-ui/react'
import Image from 'next/image'
import Link from 'next/link'
import BenefitMobile from './benefit-mobie'

const ProductCard04 = () => {
  const productData = {
    titleJP: '特别添加纯野生冬虫夏草条精华提取',
    titleEN: 'Specially added pure wild cordyceps extract',
    subTitle: '天然温和滋补 / Natural nourishment',
    descJP: `冬虫夏草的药用、滋补价值，一直都备受推崇。“补肺益肾，化痰止咳”、“秘精益气，专补命门”、
“补虚损，益精气”等独特功效，均记载于各大医学典籍中。冬虫夏草富含冬虫素、虫草酸、胺基酸、蛋白质等四十余种精华物质及多种活性酶，能有效起到抗氧化、提精力、防衰老的作用。`,
    descEN: `Cordyceps sinensis is highly valued for its tonic and medicinal properties. Renowned in major medical texts, it is noted for its unique effects, including 'tonifying the lungs and kidneys, alleviating phlegm and cough,' 'nourishing vital energy and supporting the life gate,' and 'boosting deficiency and enhancing Qi.' Rich in over 40 essential compounds and active enzymes like cordycepin, cordycepic acid, amino acids, and proteins, Cordyceps sinensis effectively promotes antioxidant activity, boosts energy, and combats aging.`,
    imageUrl:
      'https://habbit-sg.s3.ap-southeast-1.amazonaws.com/item-4-1734075592409.png'
  }
  const benefitData = [
    {
      ratio: 694 / 220,
      imageUrl:
        'https://habbit-sg.s3.ap-southeast-1.amazonaws.com/item4-1-1731602712237.png'
    },
    {
      ratio: 606 / 220,
      imageUrl:
        'https://habbit-sg.s3.ap-southeast-1.amazonaws.com/item4-2-1731602712237.png'
    }
  ]

  return (
    <Flex
      flexDir={{
        base: 'column-reverse',
        lg: 'row'
      }}
      justifyContent="space-between"
      pt={{
        base: '20px',
        lg: '105px'
      }}
      pb="80px"
      gap={5}
      id="cordyceps-sinensis"
    >
      <Box
        w={{
          base: '100%',
          lg: '60%'
        }}
      >
        {/* Title and Subtitle */}
        <Box
          w="100%"
          maxW={{
            base: '100%',
            lg: '650px'
          }}
        >
          <Text textStyle="supplementProductCardTitleJP">
            {productData.titleJP}
          </Text>

          <Text textStyle="supplementProductCardTitleEN" mt={1}>
            {productData.titleEN}
          </Text>

          <Text
            textStyle="supplementProductCardSubTitle"
            bg="#9cb25a"
            w={{
              base: 'auto',
              md: 'max-content'
            }}
            mt={5}
            color="white"
            px={2}
            py={1}
          >
            {productData.subTitle}
          </Text>

          <Text textStyle="supplementProductCardDescJP" mt={5}>
            {productData.descJP}
          </Text>

          <Text textStyle="supplementProductCardDescEN" mt={5}>
            {productData.descEN}
          </Text>
        </Box>

        {/* Benefits */}
        <Box w="100%" mt={5}>
          <AspectRatio
            ratio={1270 / 220}
            w="100%"
            display={{
              base: 'none',
              md: 'block'
            }}
          >
            <Image
              src={
                'https://habbit-sg.s3.ap-southeast-1.amazonaws.com/be-4-1731438361790.png'
              }
              alt="traditional item"
              fill
            />
          </AspectRatio>
          <Box
            display={{
              base: 'block',
              md: 'none'
            }}
          >
            <BenefitMobile items={benefitData} />
          </Box>
        </Box>

        {/* Buy Button */}
        <HStack
          justifyContent={{
            base: 'flex-start',
            md: 'flex-start'
          }}
          alignItems="center"
          gap={4}
          mt={5}
        >
          <Link href="https://habbit.sg/products/health-plus-kampo-premium-cordyceps-120s">
            <AspectRatio
              ratio={1537 / 864}
              w={{
                base: '120px',
                sm: '120px',
                md: '140px',
                lg: '160px',
                xl: '160px'
              }}
              _hover={{
                opacity: 0.7
              }}
              mt={3}
            >
              <Image
                src={
                  'https://habbit-sg.s3.ap-southeast-1.amazonaws.com/buy-now-btn-1714038035225.png'
                }
                alt="buy now btn"
                fill
              />
            </AspectRatio>
          </Link>

          <Box
            w={{
              base: '244px',
              xl: '244px'
            }}
            mt={2}
          >
            <AspectRatio ratio={123 / 36} w="100%">
              <Image
                src={
                  'https://habbit-sg.s3.ap-southeast-1.amazonaws.com/item1-certificate-1730969831994.png'
                }
                alt="traditional item"
                fill
              />
            </AspectRatio>
          </Box>
        </HStack>
      </Box>

      <Box
        w={{
          base: '100%',
          lg: '50%'
        }}
        ml={{
          base: '0',
          xl: '-5%'
        }}
      >
        <AspectRatio ratio={1258 / 1434} w="100%">
          <Image src={productData.imageUrl} alt={productData.titleEN} fill />
        </AspectRatio>
      </Box>
    </Flex>
  )
}

export default ProductCard04
